const initScrollHint = (target) => {
  new ScrollHint(target, {
    suggestiveShadow: true, // 横スクロール可能なときにシャドウを表示
    scrollHintIconAppendClass: 'scroll-hint-icon-white',
    i18n: {
      scrollable: 'スクロールできます', // 表示テキストの変更
    },
    remainingTime: -1, // ヒントが消えるまでの時間（ミリ秒）
  });
};

window.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.js-scroll-hint');
  if (targets.length > 0) {
    initScrollHint(targets);
  }
});
